import React, { useState, useEffect } from 'react';

export const CountDown = ({ deadline }) => {
   const [timeLeft, setTimeLeft] = useState(getTimeLeft(deadline));

   useEffect(() => {
      const interval = setInterval(() => {
         const time = getTimeLeft(deadline);
         if (time.total <= 0) {
            clearInterval(interval);
         } else {
            setTimeLeft(time);
         }
      }, 1000);
      return () => clearInterval(interval);
   }, [deadline]);

   function getTimeLeft(deadline) {
      const total = Date.parse(deadline) - Date.parse(new Date());
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));
      return {
         total,
         days,
         hours,
         minutes,
         seconds,
      };
   }

   const times = [
      { name: 'Days', num: timeLeft.days },
      { name: 'Hours', num: timeLeft.hours },
      { name: 'Minutes', num: timeLeft.minutes },
      { name: 'Seconds', num: timeLeft.seconds },
   ]

   return (
      <div className='count-down'>
         <div className='times'>
            {times.map((time) => {
               return (
                  <div
                     className='time'
                     key={time.name}
                  >
                     <span>{time.num}</span>
                     <h6>{time.name}</h6>
                  </div>
               );
            })}
         </div>
      </div>
   );
};